import c from './styles.module.scss'

const TextBlock = ({children, html}) => {
    return (
        html !== undefined
            ? <div className={c.textBlock} dangerouslySetInnerHTML={{ __html: html }} />
            : <div className={c.textBlock}>{children}</div>
    )
}

export default TextBlock
